import React from 'react'
import { Box, Button } from '@mui/material'

import { useNavigate } from 'react-router-dom'

const ErrorPage = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        color: 'white',
        height: '100vh',
        overflowY: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80dvh',
          width: '100%',
          flexDirection: 'column',
        }}
      >
        <Button variant="outlined" onClick={() => navigate('/')} sx={{ marginTop: 4 }}>
          Home Page
        </Button>
      </Box>
    </Box>
  )
}

export default ErrorPage
